import { render, staticRenderFns } from "./notifySettings.vue?vue&type=template&id=69fd08ab&scoped=true"
import script from "./notifySettings.vue?vue&type=script&lang=js"
export * from "./notifySettings.vue?vue&type=script&lang=js"
import style0 from "./notifySettings.vue?vue&type=style&index=0&id=69fd08ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fd08ab",
  null
  
)

export default component.exports